// 🔧 nav_wrapper.js
// ✅ Purpose: Global/public route layout wrapper
// ✅ Features:
// - Shows ResponsiveNav for non-event/global pages
// - Supports the manager/admin left sidebar layout
// - Preserves existing public/global routing through <Outlet />
// - Keeps footer below global routed pages
// - Uses the same content shell classes as event layout

import React from "react";
import { Outlet } from "react-router-dom";
import ResponsiveNav from "../components/ResponsiveNav";
import Footer from "../components/footer";

const NavWrapper = () => {
  return (
    <div className="lgv-page-shell">

      <ResponsiveNav />

      <main className="lgv-route-content">
        <Outlet />
      </main>

      <Footer />

    </div>
  );
};

export default NavWrapper;